<plan-personal-alumno [planPersonalId]="planPersonalId"></plan-personal-alumno>
